<template>
  <form
    id="update-profile"
    @submit="checkForm"
    action="#"
    method="post"
    novalidate="true"
  >
    <div class="col-wrap">
      <div class="col">
        <label class="required" for="name-first">{{
          $t("profile.profileUpdateForm.firstName")
        }}</label>
        <input
          id="name-first"
          v-bind:class="{ error: errNameFirst }"
          name="name-first"
          v-model="nameFirst"
          v-on:input="
            updateForm = true;
            errNameFirst = false;
          "
        />
        <p class="error" v-if="errNameFirst">
          {{ $t("profile.profileUpdateForm.errorMsg.noFirstName") }}
        </p>

        <label class="required" for="name-last">{{
          $t("profile.profileUpdateForm.lastName")
        }}</label>
        <input
          id="name-last"
          v-bind:class="{ error: errNameLast }"
          name="name-last"
          v-model="nameLast"
          v-on:input="
            updateForm = true;
            errNameLast = false;
          "
        />
        <p class="error" v-if="errNameLast">
          {{ $t("profile.profileUpdateForm.errorMsg.noLastName") }}
        </p>

        <label class="" for="phone">{{
          $t("profile.profileUpdateForm.phoneNumber")
        }}</label>
        <input
          id="phone"
          v-bind:class="{ error: errPhone }"
          name="phone"
          v-model="phone"
          v-on:input="
            updateForm = true;
            errPhone = false;
          "
        />
        <p class="error" v-if="errPhone">
          {{ $t("profile.profileUpdateForm.errorMsg.invalidPhone") }}
        </p>
      </div>

      <div class="col">
        <label class="" for="company">{{
          $t("profile.profileUpdateForm.companyName")
        }}</label>
        <input
          id="company"
          v-bind:class="{ error: errCompany }"
          name="company"
          v-model="company"
          v-on:input="
            updateForm = true;
            errCompany = false;
          "
        />
        <p class="error" v-if="errCompany">
          {{ $t("profile.profileUpdateForm.errorMsg.invalidCompany") }}
        </p>

        <label class="" for="industry">{{
          $t("profile.profileUpdateForm.industry")
        }}</label>
        <select
          id="industry"
          name="industry"
          v-model="selectedIndustry"
          v-on:change="updateForm = true"
        >
          <option default disabled :value="null">
            {{ $t("profile.profileUpdateForm.placeholder") }}
          </option>
          <option
            v-for="(industry, index) in industries"
            v-bind:key="index"
            v-bind:value="industry.value"
          >
            {{ industry.text }}
          </option>
        </select>

        <label class="required" for="country">{{
          $t("profile.profileUpdateForm.country")
        }}</label>
        <select
          id="country"
          name="country"
          v-model="selectedCountry"
          v-on:change="updateForm = true"
        >
          <option
            v-for="(country, countryCode) in countries"
            v-bind:key="countryCode"
            v-bind:value="countryCode"
          >
            {{ country }}
          </option>
        </select>

        <label class="required" for="lang">{{
          $t("profile.profileUpdateForm.language")
        }}</label>
        <select
          id="lang"
          name="lang"
          v-model="languageCode"
          v-on:change="updateForm = true"
        >
          <option
            v-for="(language, index) in languages"
            v-bind:key="index"
            v-bind:value="language.value"
          >
            {{ language.text }}
          </option>
        </select>

        <label class="" for="betaEnabled">{{
          $t("profile.profileUpdateForm.betaEnabled")
        }}</label>
        <input
          type="checkbox"
          id="betaEnabled"
          v-model="betaEnabled"
          v-on:input="updateForm = true"
        />
      </div>
    </div>

    <div class="col-wrap auth-req">
      <div class="col">
        <p class="error">{{ $t("profile.profileUpdateForm.text") }}</p>

        <label v-bind:class="{ required: updateFormAuth }" for="pass-old">{{
          $t("profile.profileUpdateForm.oldPw")
        }}</label>
        <input
          type="password"
          v-bind:class="{ error: errPasswordOld }"
          name="password-old"
          id="pass-old"
          v-model="passwordOld"
          v-on:input="
            errPasswordOld = false;
            wrongPasswordOld = false;
          "
        />
        <p class="error" v-if="errPasswordOld">
          {{ $t("profile.profileUpdateForm.errorMsg.noPasswordOld") }}
        </p>
        <p class="error" v-if="wrongPasswordOld">
          {{ $t("profile.profileUpdateForm.errorMsg.wrongPasswordOld") }}
        </p>
      </div>

      <div class="col">
        <label class="" for="email">{{
          $t("profile.profileUpdateForm.email")
        }}</label>
        <input
          id="email"
          v-bind:class="{ error: errEmail }"
          name="email"
          v-model="email"
          v-on:input="updateFormAuth = true"
        />
        <p class="error" v-if="errEmail">
          {{ $t("profile.profileUpdateForm.errorMsg.noEmail") }}
        </p>
        <p class="error" v-if="invalidEmail">
          {{ $t("profile.profileUpdateForm.errorMsg.invalidEmail") }}
        </p>

        <label class="" for="pass">{{
          $t("profile.profileUpdateForm.newPw")
        }}</label>
        <span v-if="errPasswordReuse" class="error">
          {{ $t("profile.profileUpdateForm.errorMsg.latestPw") }}
        </span>
        <span v-if="errPasswordStrength" class="error">
          {{ $t("profile.profileUpdateForm.errorMsg.invalidPw") }}
        </span>
        <input
          type="password"
          v-bind:class="{
            error: errPassword || errPasswordReuse || errPasswordStrength,
          }"
          name="password"
          id="pass"
          v-model="password"
          v-on:input="
            updateFormAuth = true;
            errPassword = false;
            errPasswordReuse = false;
            errPasswordStrength = false;
          "
        />
        <p class="error" v-if="errPassword">
          {{ $t("profile.profileUpdateForm.errorMsg.noPassword") }}
        </p>
      </div>
    </div>

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('profile.profileUpdateForm.button.update')"
      v-if="updateForm || updateFormAuth"
    />
  </form>
</template>

<script>
import { userService } from "@/services/user.service";
import { countries } from "@/utils/countries";
import { validPhone } from "@/utils/validPhone";
import { validEmail } from "@/utils/validEmail";
import { validFileInclusion } from "@/utils/validFileInclusion";
import { defaultLanguage, language } from "@/utils/language";

export default {
  name: "ProfileUpdateFrom",
  data() {
    let user = JSON.parse(localStorage.getItem("user"));
    let languageCode = user.userInfo.languageCode;
    if (!language().some((x) => x.value === languageCode)) {
      languageCode = defaultLanguage();
    }
    return {
      invalidForm: true,
      updateForm: false,
      updateFormAuth: false,
      errNameFirst: false,
      errNameLast: false,
      errPhone: false,
      errCompany: false,
      errWebsite: false,
      errEmail: false,
      errPassword: false,
      errPasswordReuse: false,
      errPasswordStrength: false,
      errPasswordOld: false,
      wrongPasswordOld: false,
      invalidEmail: false,

      nameFirst: user.userInfo.givenName,
      nameLast: user.userInfo.familyName,
      phone: user.userInfo.phoneNumber,
      company: user.userInfo.companyName,
      languageCode: languageCode,
      website: user.userInfo.businessWebsiteDomain,
      email: user.userInfo.emailAddress,
      password: null,
      passwordOld: null,

      selectedIndustry: user.userInfo.industry,
      industries: [
        {
          text: this.$t("profile.profileUpdateForm.select.item01"),
          value: "Consumer",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item02"),
          value: "Education",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item03"),
          value: "Energy & Utilities",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item04"),
          value: "Finance",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item05"),
          value: "Government",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item06"),
          value: "Healthcare",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item07"),
          value: "Manufacturing",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item08"),
          value: "Materials",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item09"),
          value: "Non-profit",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item10"),
          value: "Professional Services",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item11"),
          value: "Research",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item12"),
          value: "Technology",
        },
        {
          text: this.$t("profile.profileUpdateForm.select.item13"),
          value: "Transportation",
        },
      ],

      selectedCountry: user.userInfo.countryOrRegion,
      countries: countries(),
      languages: language(),

      betaEnabled: user.userInfo.betaEnabled,
    };
  },
  methods: {
    checkForm: function (event) {
      this.invalidForm = false;
      this.errNameFirst = false;
      this.errNameLast = false;
      this.errPhone = false;
      this.errCompany = false;
      this.errWebsite = false;
      this.errPassword = false;
      this.errPasswordReuse = false;
      this.errPasswordStrength = false;
      this.errPasswordOld = false;

      if (!this.nameFirst || validFileInclusion(this.nameFirst)) {
        this.invalidForm = true;
        this.errNameFirst = true;
      }

      if (!this.nameLast || validFileInclusion(this.nameLast)) {
        this.invalidForm = true;
        this.errNameLast = true;
      }

      if (this.phone && !validPhone(this.phone)) {
        this.invalidForm = true;
        this.errPhone = true;
      }

      if (this.company && validFileInclusion(this.company)) {
        this.invalidForm = true;
        this.errCompany = true;
      }

      // Make sure they've entered something in 'Old password'
      // if trying to change something authy.
      if (this.updateFormAuth) {
        if (this.passwordOld === null || validFileInclusion(this.passwordOld)) {
          this.invalidForm = true;
          this.errPasswordOld = true;
        }
        if (this.password && validFileInclusion(this.password)) {
          this.invalidForm = true;
          this.errPassword = true;
        }
        if (!validEmail(this.email)) {
          this.invalidForm = true;
          this.errEmail = true;
        }
      }

      // Form passed validation!
      if (!this.invalidForm) {
        this.createProfile();
      }

      event.preventDefault();
    },

    createProfile: function () {
      let me = JSON.parse(localStorage.getItem("user"));

      let userUpdate = {
        givenName: this.nameFirst,
        familyName: this.nameLast,
        countryOrRegion: this.selectedCountry,
        companyName: this.company,
        languageCode: this.languageCode,
        industry: this.selectedIndustry,
        businessWebsiteDomain: this.website,
        phoneNumber: this.phone,
        betaEnabled: this.betaEnabled,
      };

      if (this.updateFormAuth) {
        userUpdate.currentPassword = this.passwordOld;
        userUpdate.emailAddress = this.email;
        if (this.password) {
          userUpdate.newPassword = this.password;
        }
      }

      userService
        .update(userUpdate)
        .then((userInfo) => {
          // Update our local store of the profile.
          me.userInfo = userInfo;
          localStorage.setItem("user", JSON.stringify(me));
          this.$i18n.locale = this.languageCode;
          localStorage.setItem("lang", this.languageCode);
          this.$router.push("plans");
        })
        .catch((err) => {
          console.log(typeof err);
          if (err === "Field 'new password' is not a valid password") {
            this.invalidForm = true;
            this.errPasswordStrength = true;
          } else if (
            err === "You have already used this password in the past"
          ) {
            this.invalidForm = true;
            this.errPasswordReuse = true;
          }
          if (err === "") {
            this.invalidForm = true;
            this.wrongPasswordOld = true;
          }
        });
    },
  },
  watch: {
    combinedVars: {
      handler([errNameFirst, errNameLast, errPhone, errCompany]) {
        if (errNameFirst || errNameLast || errPhone || errCompany) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      },
      immediate: true,
      deep: false,
    },
  },
  computed: {
    combinedVars() {
      return [
        this.errNameFirst,
        this.errNameLast,
        this.errPhone,
        this.errCompany,
      ];
    },
  },
};
</script>
<style lang="scss">
#update-profile {
  .col-wrap {
    max-width: 900px;
  }
  input.submit {
    @extend button;
    width: auto;
  }
  .auth-req {
    margin-top: 15px;
    padding-top: 30px;
    border-top: 2px solid #ccc;
  }
  p {
    margin: -17px 0px 25px !important;
  }
}
</style>
